import styled from "styled-components";


export const DummyButton = styled.button`
    font-family: Inter, sans-serif;
    cursor: pointer;
    display: inline-flex;
    -webkit-box-align: center;
    align-items: center;
    -webkit-box-pack: center;
    justify-content: center;
    border: 1px solid #bdbdbd;
    height: 30px;
    background-color: #bcbdbd;
    font-size: 14px;
    color: white;
    border-radius: 6px;
    padding: 0px 17px;
    text-decoration: none;
    letter-spacing: 0.2px;
    font-weight: 500;
    min-width: 150px;
    text-align: center;
    transition: all 0.2s ease;
    opacity: 1;
`;


export const DragDropAreaContainer = styled.div`
  margin-bottom: 16px;
  padding: 16px;
  text-align: center;
  background-color: #fafafa;
  transition: all 0.2s ease;
  cursor: pointer;

  border: 1px dashed #999;
  border-radius: 8px;
  color: #bdbdbd;
  outline: none;

  &.has-file {
    border-color: ${(props) => props.theme.colors.Primary};
    background-color: #f8f9ff;
    border-style: solid;
    color: ${(props) => props.theme.colors.Primary};

    i:before {
      background-color: ${(props) => props.theme.colors.Primary};
    }
  }

  &.has-file:hover {
    background-color: #f0f4ff;
    border-color: ${(props) => props.theme.colors.Primary};

    i:before {
      background: ${(props) => props.theme.colors.Primary};
    }
  }

  i:before {
    transition: all 0.2s ease;
  }

  &:hover {
    background-color: #f0f0f0;
    border-color: ${(props) => props.theme.colors.Primary};
    color: ${(props) => props.theme.colors.Primary};

    i:before {
      background-color: ${(props) => props.theme.colors.Primary};
    }

    ${DummyButton} {
      background-color: ${(props) => props.theme.colors.Primary};
      border: 1px solid ${(props) => props.theme.colors.Primary};
      color: #fff;
    }
  }

  &:active {
    background-color: #e8e8e8;
    border-color: ${(props) => props.theme.colors.Primary};
    color: ${(props) => props.theme.colors.Primary};

    i:before {
      background-color: ${(props) => props.theme.colors.Primary};
    }
  }
`;

export const DragDropLabel = styled.label`
  display: block;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0px;
`;

export const DragDropText = styled.p`
  font-size: 12px;
  margin-top: 0px;
  margin-bottom: 0px;
  line-height: 1.4;
`;

export const FileInfo = styled.div`
  color: ${(props) => props.theme.colors.Primary};
`;
